// dependencies
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import * as dateFns from "date-fns";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// container
import Content from "Containers/Content";
import Notifications from "Containers/Notifications";
import TopNavigation from "Containers/Navigation/Top";

// components
import EnvironmentContext from "./EnvironmentContext";

// actions
import { applicationInit } from "Actions/app";

// selectors
import { getPageHasNavigation, getCurrentEnvironmentName, getPageName, getUserIsAdmin } from "Selectors/app";

// Create a client
const queryClient = new QueryClient();

// assets
import css from "./App.styl";

class Application extends React.PureComponent {
	static propTypes = {
		pageName: PropTypes.string,
		init: PropTypes.func.isRequired,
		showNavigation: PropTypes.bool.isRequired,
		userIsAdmin: PropTypes.bool.isRequired,
		environment: PropTypes.string.isRequired,
	};

	static defaultProps = {
		pageName: null,
	};

	constructor(props) {
		super(props);
		this.props.init();

		window.dateFns = dateFns;
	}

	render() {
		const { userIsAdmin, pageName, showNavigation, environment } = this.props;

		return (
			<QueryClientProvider client={queryClient}>
				<div className={css.App}>
					{showNavigation ? <TopNavigation currentPage={pageName} userIsAdmin={userIsAdmin} /> : null}

					<div className={showNavigation ? css.ContainerWrapper : ""}>
						<EnvironmentContext.Provider value={environment}>
							<Content />
						</EnvironmentContext.Provider>
					</div>

					<Notifications />
				</div>
			</QueryClientProvider>
		);
	}
}

const mapStateToProps = (state) => ({
	pageName: getPageName(state),
	userIsAdmin: getUserIsAdmin(state),
	showNavigation: getPageHasNavigation(state),
	environment: getCurrentEnvironmentName(state),
});

const mapDispatchToProps = (dispatch) => ({
	init: () => dispatch(applicationInit()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Application);
